import { LinearProgress } from "@mui/material";

export default function ProgressHT({value}) {

    let color = "error"
    if (value > 50) color = "warning"
    if (value > 99) color = "success"
    

return (
  <LinearProgress
    value={value}
        variant="determinate"
        color={color}
  />
);
}